<script>
import {
  getParkSpaceNode,
  getCarInList,
  getCarOutList,
  getRemainList,
} from '@/api/v4ward/carv2/carinoutinfo';

export default {
  methods: {
    //车辆入场导出
    intoExportExcel(query) {
      this.$confirm('确定导出所选条件下的数据吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        //设置导出标识
        query.exportExcelFlag = 0;
        getCarInList(Object.assign({}, query)).then(({ data }) => {
          console.log(data);
          var spaceName;
          if (data != null && data.records.length > 0) {
            spaceName = data.records[0].spaceName;
          } else {
            this.$message.error('当前条件下无数据');
            return;
          }
          // 需要导出的数据，可以动态获取
          import('@/vendor/Export2Excel.js').then((excel) => {
            // 导入js模块
            const tHeader = [
              '车场名称',
              '车牌号',
              '车辆类型',
              '入场时间',
              '入场通道名称',
              '是否出场',
              '操作类型',
            ]; // 导出excel 的标题
            const filterVal = [
              'spaceName',
              'carNo',
              'carType',
              'inTime',
              'inPassageName',
              'outStatus',
              'parkEventType',
            ]; // 每个标题对应的字段
            const list = (data.records || []).map((item, key) => {
              // 通过 map 方法遍历，组装数据成上面的格式
              return {
                spaceName: item.spaceName,
                carNo: item.carNo,
                carType: item.carType,
                inTime: item.inTime ? this.dayjs(item.inTime).format('YYYY-MM-DD HH:mm:ss') : '',
                inPassageName: item.inPassageName,
                inPic: item.inPic,
                outStatus: item.outStatus,
                parkEventType: item.parkEventType,
              };
            });
            if (list.length > 0) {
              const data = this.formatJson(filterVal, list); // 生成json数据
              excel.export_json_to_excel({
                // 调用excel方法生成表格
                header: tHeader,
                data,
                filename:
                  spaceName + '车辆入场记录' + this.dayjs(new Date()).format('YYYYMMDDHHmmss'),
              });
            }
          });
        });
      });
    },
    //车辆在场导出
    remainExportExcel(query) {
      this.$confirm('确定导出所选条件下的数据吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        //设置导出标识
        query.exportExcelFlag = 0;
        getRemainList(Object.assign({}, query)).then(({ data }) => {
          var spaceName;
          if (data != null && data.records.length > 0) {
            spaceName = data.records[0].spaceName;
          } else {
            this.$message.error('当前条件下无数据');
            return;
          }
          // 需要导出的数据，可以动态获取
          import('@/vendor/Export2Excel.js').then((excel) => {
            // 导入js模块
            const tHeader = [
              '车场名称',
              '车牌号',
              '车辆类型',
              '入场时间',
              '在场时长',
              '入场通道名称',
            ]; // 导出excel 的标题
            const filterVal = [
              'spaceName',
              'carNo',
              'carType',
              'inTime',
              'parkingTime',
              'inPassageName',
            ]; // 每个标题对应的字段
            const list = (data.records || []).map((item, key) => {
              // 通过 map 方法遍历，组装数据成上面的格式
              return {
                spaceName: item.spaceName,
                carNo: item.carNo,
                carType: item.carType,
                inTime: item.inTime ? this.dayjs(item.inTime).format('YYYY-MM-DD HH:mm:ss') : '',
                parkingTime: item.parkingTime,
                inPassageName: item.inPassageName,
              };
            });
            if (list.length > 0) {
              const data = this.formatJson(filterVal, list); // 生成json数据
              excel.export_json_to_excel({
                // 调用excel方法生成表格
                header: tHeader,
                data,
                filename:
                  spaceName + '车辆在场记录' + this.dayjs(new Date()).format('YYYYMMDDHHmmss'),
              });
            }
          });
        });
      });
    },

    //车辆出场导出
    outExportExcel(query) {
      this.$confirm('确定导出所选条件下的数据吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        //设置导出标识
        query.exportExcelFlag = 0;
        getCarOutList(Object.assign({}, query)).then(({ data }) => {
          var spaceName;
          if (data != null && data.records.length > 0) {
            spaceName = data.records[0].spaceName;
          } else {
            this.$message.error('当前条件下无数据');
            return;
          }
          // 需要导出的数据，可以动态获取
          import('@/vendor/Export2Excel.js').then((excel) => {
            // 导入js模块
            const tHeader = [
              '车场名称',
              '区域名称',
              '车牌号',
              '车辆类型',
              '出场时间',
              '停车时长',
              '出场通道名称',
              '应缴金额',
              '收费金额',
              '收费方式',
              '出场备注',
              '入场时间',
              '入场通道名称',
            ]; // 导出excel 的标题
            const filterVal = [
              'spaceName',
              'regionName',
              'carNo',
              'carType',
              'outTime',
              'parkTime',
              'outPassageName',
              'payableMoney',
              'chargeMoney',
              'payType',
              'outMemo',
              'inTime',
              'inPassageName',
            ]; // 每个标题对应的字段
            const list = (data.records || []).map((item, key) => {
              // 通过 map 方法遍历，组装数据成上面的格式
              return {
                spaceName: item.spaceName,
                regionName: item.regionName,
                carNo: item.carNo,
                carType: item.carType,
                outTime: item.outTime ? this.dayjs(item.outTime).format('YYYY-MM-DD HH:mm:ss') : '',
                parkTime: item.parkTime,
                outPassageName: item.outPassageName,
                payableMoney: item.payableMoney,
                chargeMoney: item.chargeMoney,
                //....
                payType: item.payType,
                outMemo: item.outMemo,
                inTime: item.inTime ? this.dayjs(item.inTime).format('YYYY-MM-DD HH:mm:ss') : '',
                inPassageName: item.inPassageName,
              };
            });
            if (list.length > 0) {
              const data = this.formatJson(filterVal, list); // 生成json数据
              excel.export_json_to_excel({
                // 调用excel方法生成表格
                header: tHeader,
                data,
                filename:
                  spaceName + '车辆出场记录' + this.dayjs(new Date()).format('YYYYMMDDHHmmss'),
              });
            }
          });
        });
      });
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>

<style></style>
